import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import { SENTRY_ERROR_TYPE } from 'constants/sentry.constants';
import { ptpCatchError } from 'services/sentry.services';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    ptpCatchError(error, errorInfo, {
      tags: {
        error_type: SENTRY_ERROR_TYPE.UI_CRASH,
      },
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <h1>[PTP] Something went wrong.</h1>;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
